import { Box } from '@mui/material'
import { openSyntheticDataDocumentSection } from '@/features/documentPreview/openSyntheticDataDocumentSection'
import { docSectionId, isDocRef, safeHref } from '../InlineFormat/safeHref'
import styles from '../FormattedAgentText.module.scss'

const linkSx = { color: 'var(--app-primary)', textDecorationColor: 'currentColor' }

/**
 * `doc:` hrefs open the in-app document preview rather than navigating, and
 * everything else passes through the scheme allowlist. `urlTransform` in the
 * adapter is the first gate; this is the second, because a rejected URL is
 * handed here as an empty string and must not render as a live anchor.
 */
export default function MarkdownLink({ href, children }) {
  if (isDocRef(href)) {
    return (
      <button
        type="button"
        className={styles.docRef}
        onClick={() => openSyntheticDataDocumentSection(docSectionId(href))}
      >
        {children}
      </button>
    )
  }

  const url = safeHref(href)
  if (!url) return <span>{children}</span>

  return (
    <Box component="a" href={url} target="_blank" rel="noopener noreferrer" sx={linkSx}>
      {children}
    </Box>
  )
}
